import { IRevenueSpendCrudModalLang } from '../../../types/lang'

export const revenueSpendCrudModalLang: IRevenueSpendCrudModalLang = {
	revenue_spend_crud_modal: {
		title_create: 'Create revenue spend_ua',
		title_edit: 'Edit revenue spend_ua',
		title_remove_single: 'Remove <span>revenue spend_ua</span>',
		title_notes_view: 'View notes for revenue spend_ua',
		title_notes_edit: 'Edit notes for revenue spend_ua',
		title_history_view: 'View history in revenue spend_ua',
		title_select_users: 'Revenue spend select users (buyers) for revenue agency_ua',
		label_mode_revenue_cpa: 'Revenue Cpa_ua',
		label_mode_revenue_spend: 'Revenue Spend_ua',
		label_mode_revenue: 'Revenue_ua',
		title_by_account_revenue: 'View revenue spend - {{mode}} - detail info by account {{account}} - {{date}}_ua',
		title_by_account_revenue_total: 'View TOTAL revenue spend - {{mode}} - detail info_ua',
		title_by_account_offer_spend: 'View revenue spend - Revenue Offer Spend - detail info by account {{account}} - {{date}}_ua',
		title_by_account_offer_spend_total: 'View TOTAL revenue spend - Revenue Offer Spend - detail info_ua',
		title_by_account_spend: 'View revenue spend - Spend - detail info by account {{account}} - {{date}}_ua',
		title_by_account_spend_total: 'View TOTAL revenue spend - Spend - detail info_ua',
		title_by_team_revenue: 'View revenue spend - {{mode}} - detail info by team {{team}} - {{date}}_ua',
		title_by_team_revenue_total: 'View TOTAL revenue spend - {{mode}} - detail info_ua',
		title_by_team_offer_spend: 'View revenue spend - Revenue Offer Spend - detail info by team {{team}} - {{date}}_ua',
		title_by_team_offer_spend_total: 'View TOTAL revenue spend - Revenue Offer Spend - detail info_ua',
		title_by_team_spend: 'View revenue spend - Spend - detail info by team {{team}} - {{date}}_ua',
		title_by_team_spend_total: 'View TOTAL revenue spend - Spend - detail info_ua',
		field_agency_label: 'Agency_ua',
		field_agency_placeholder: 'Agency_ua',
		field_account_label: 'Account_ua',
		field_account_placeholder: 'Account_ua',
		field_kt_group_label: 'KT Group_ua',
		field_kt_group_placeholder: 'KT Group_ua',
		field_date_label: 'Date_ua',
		field_date_placeholder: 'Date_ua',
		field_amount_label: 'Amount_ua',
		field_amount_placeholder: 'Type number_ua',
		field_notes_label: 'Notes_ua',
		field_notes_placeholder: 'Notes_ua',
		msg_remove_confirm: 'Are you sure?_ua',
		btn_select_users: 'Select Users (Buyers)_ua',
		btn_create: 'Create_ua',
		btn_update: 'Save_ua',
		btn_remove: 'Remove_ua',
		btn_close: 'Close_ua'
	}
}